export default {
  regionLabel: {
    id: 'shopping_assistant_gifting_card_carousel_region_label',
    defaultMessage: 'Gift cards',
  },
} as const
